import React, { useState } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';
import 'moment/locale/zh-cn';
import 'moment/locale/ru';
moment.locale('zh-cn');
moment.locale('ru');

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  margin-top: 20px;
  .header-title {
    margin-bottom: 15px;
  }
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .order-history-wrapper {
    display: flex;
    color: #9698a0;
    .order-history-date {
      min-width: 120px;
      width: 120px;
      margin-right: 16px;
      font-size: 12px;
    }
    .order-history-status {
      position: relative;
      font-weight: bold;
      color: #72747b;
      padding-left: 12px;
      border-left: 3px solid #d0d0d0;
      padding-bottom: 30px;
      min-width: 120px;
      margin-right: 18px;
      &:before {
        content: '';
        position: absolute;
        left: -9px;
        top: 0;
        border: 3px solid #d0d0d0;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background-color: #f2f5f7;
      }
    }
    .order-histoty-text {
      //margin-right: 18px;
      min-width: 250px;
      .order-history-subtype {
        color: #72747b;
      }
    }
    .order-history-description {
      margin-bottom: 10px;
    }
    .order-history-icon {
      margin-left: auto;
      font-size: 15px;
      color: #d6d6d6;
    }

    &.full-mode:last-child {
      .order-history-status {
        border-left: none;
        padding-left: 15px;
        &:before {
          left: -6px;
        }
      }
    }
  }
  .more-link-wrapper {
    display: flex;
    padding-top: 9px;
    border-top: 1px solid #ebebeb;
    margin-top: -10px;
    padding-left: 0;
    padding-right: 0;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    div {
      margin-left: auto;
      color: #72747b;
      cursor: pointer;
    }
  }
`;

const DesktopHistoryBlock = (props) => {
  const { supplyHistory } = props;

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  const [fullMode, setFullState] = useState(false);

  const filteredData = fullMode
    ? supplyHistory.slice().reverse()
    : supplyHistory.slice().reverse().slice(0, 5);

  return (
    <Wrapper>
      <div>
        <h4 className="header-title">{t('История поставки')}</h4>
      </div>
      <div>
        {filteredData.map((h) => (
          <div key={h.id} className={`order-history-wrapper ${fullMode ? 'full-mode' : ''}`}>
            <div className="order-history-date ">
              {moment(h.eventDate).locale(localeCode).format('DD MMM YYYY HH:mm:ss')}
            </div>
            <div className="order-history-status">{t(h.orderDocStage)}</div>
            <div className="order-histoty-text">
              <div className="order-history-subtype">{h.subType}</div>
              {h.description ? (
                <div className="order-history-description">{h.description}</div>
              ) : null}
            </div>
            {/* <div className="order-history-icon">
                            <i className="fe-monitor" />
                        </div> */}
          </div>
        ))}
      </div>
      {!fullMode ? (
        <div className="more-link-wrapper">
          <div onClick={() => setFullState(true)}>{t('Полная история')}</div>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default DesktopHistoryBlock;
